<template>
    <modal
        :header="$t('header')"
        name="tourModal"
        isLarge="true">
        <div class="envelope-guide">
            <div class="envelope-guide__wrapper" v-if="showSlideShow">
              <component :is="selectedSlide"></component>
            </div>
            <div class="envelope-guide__welcome" v-else>
            {{ $t('envelopeGuide.unsureWhatToDoNext') }}
            </div>
            <div class="envelope-guide__slider__buttons" v-if="showSlideShow">
            <a class="envelope-guide__slider__prev" @click="prev" v-if="slidePosition > 0">
                <icon name="chevron-left" height="20"></icon>
            </a>
            <a class="envelope-guide__slider__next" @click="next" v-if="slidePosition < (slideLength - 1)">
                <icon name="chevron-right" height="20"></icon>
            </a>
            </div>
        </div>
        <template slot="modalButtons" slot-scope="props">
            <BaseButton
              @click.native="props.close"
              variant="secondary"
              size="large"
            >
              {{ continueButtonText }}
            </BaseButton>
            <BaseButton
              v-if="showModalButtons"
              @click.native="startSlideShow"
              size="large"
              class="float-right"
            >
              {{ $t('functional.takeTour') }}
            </BaseButton>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal'
import BaseButton from '@/components/library/buttons/BaseButton.vue'
import EnvelopeGuidePage1 from '@/components/tour/page-1'
import EnvelopeGuidePage2 from '@/components/tour/page-2'
import EnvelopeGuidePage3 from '@/components/tour/page-3'
import EnvelopeGuidePage4 from '@/components/tour/page-4'
import EnvelopeGuidePage5 from '@/components/tour/page-5'
import EnvelopeGuidePage6 from '@/components/tour/page-6'
import EnvelopeGuidePage7 from '@/components/tour/page-7'

/* eslint no-param-reassign: ["error", { "props": false }] */
export default {
  name: 'envelope-guide',
  components: {
    Modal,
    BaseButton,
    EnvelopeGuidePage1,
    EnvelopeGuidePage2,
    EnvelopeGuidePage3,
    EnvelopeGuidePage4,
    EnvelopeGuidePage5,
    EnvelopeGuidePage6,
    EnvelopeGuidePage7
  },
  data () {
    return {
      showSlideShow: false,
      slidePosition: 0,
      showModalButtons: true
    }
  },
  computed: {
    continueButtonText () {
      return this.showModalButtons ? this.$t('functional.continueToDoc') : this.$t('functional.close')
    },
    selectedSlide () {
      return `EnvelopeGuidePage${this.slidePosition + 1}`
    },
    slides () {
      return [
        'EnvelopeGuidePage1',
        'EnvelopeGuidePage2',
        'EnvelopeGuidePage3',
        'EnvelopeGuidePage4',
        'EnvelopeGuidePage5',
        'EnvelopeGuidePage6',
        'EnvelopeGuidePage7'
      ]
    },
    slideLength () {
      return this.slides.length
    }
  },
  methods: {
    prev () {
      this.slidePosition -= 1
    },
    next () {
      this.slidePosition += 1
    },
    startSlideShow () {
      this.showSlideShow = true
      this.showModalButtons = false
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .envelope-guide
    &__welcome
      font-size: 18px
      line-height: 1.5
    &__wrapper
      max-width: 790px
      width: 100%
      overflow: hidden
    &__slider
      padding: 0
      margin: 0
      list-style: none
      text-align: center
      line-height: 1.5
      font-size: 20px
      font-weight: bold
      transition: all .25s ease
      li
        float: left
        padding: $spacing-base
        svg:not(.fa-icon)
          height: auto
          width: 100%
      img
        min-height: 250px
      &__buttons
        position: absolute
        width: 100%
        top: 50%
        a
          position: absolute
          background: #fff
          border-radius: 30px
          color: $color-main-dark
          padding: $spacing-small $spacing-base
          line-height: 0
          box-shadow: 0 5px 20px -5px $color-grey-dark
          cursor: pointer
          &:hover
            background: $color-main
            color: #fff
          .fa-icon
            margin: 0
      &__prev
        left: -56px - $spacing-base
      &__next
        right: -26px - $spacing-base
  //responsive
  @media screen and (max-width: $screen-size-large)
    .envelope-guide
      &__slider
        img
          min-height: 0
        &__buttons
          width: 0%
          bottom: 57px
          right: 60px
          top: initial
</style>
